<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
    <v-container class="whitesmoke pa-0">
        <v-row class="whitesmoke tab" no-gutters>
            <v-alert
                v-if="device?.data?.properties?.iaq === undefined"
                color="error"
                class="mx-1"
                dense
                outlined
                icon="mdi-alert-circle-outline"
                type="error"
                >
                {{$t('comboNoData')}}
            </v-alert>
        </v-row>
        <v-row v-if="device?.data?.properties?.iaq !== undefined" class="whitesmoke tab" no-gutters>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.iaq.t_r !== undefined"
                :title="$t('temperature')"
                :title_number="device?.data?.properties?.iaq.t_r?.toFixed(1)"
                text_font_size="20px"
                unit="celsius"
                card_icon="mdi-home-thermometer"
                card_icon_color="green"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.iaq.t_out !== undefined"
                :title="$t('outdoor_temperature')"
                :title_number="device?.data?.properties?.iaq.t_out?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-cloud"
                unit="celsius"
                card_icon_color="blue"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.iaq.rh_r !== undefined"
                :title="$t('relative_humidity')"
                :title_number="device?.data?.properties?.iaq.rh_r?.toFixed(1)"
                text_font_size="20px"
                unit="percentage"
                card_icon="mdi-water-percent"
                card_icon_color="cyan"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.iaq.co2_r !== undefined"
                :title="$t('co2')"
                :title_number="device?.data?.properties?.iaq.co2_r?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-molecule-co2"
                unit="ppm"
                card_icon_color="blue"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.iaq.lux !== undefined"
                :title="$t('lux')"
                :title_number="device?.data?.properties?.iaq.lux?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-brightness-4"
                unit="lux"
                card_icon_color="yellow"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.iaq.pm2_5 !== undefined"
                :title="$t('number_particulate_matter') + '2.5'"
                :title_number="device?.data?.properties?.iaq.pm2_5?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-weather-dust"
                unit="pm"
                card_icon_color="red"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.iaq.mc_pm2_5 !== undefined"
                :title="$t('mass_particulate_matter') + '2.5'"
                :title_number="device?.data?.properties?.iaq.mc_pm2_5?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-weather-dust"
                unit="mc_pm"
                card_icon_color="red"
            ></DeviceOverviewCard>
        </v-row>
    </v-container>
</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import DashboardCardBarChart from "@/components/Cards/DashboardCardBarChart.vue";
import DashboardCardPieChart from "@/components/Cards/DashboardCardPieChart.vue";
import DeviceOverviewCard from "@/components/Cards/DeviceOverviewCard.vue";
import DeviceOverviewSwitchCard from "@/components/Cards/DeviceOverviewSwitchCard.vue";
import DeviceOverviewButtonCard from "@/components/Cards/DeviceOverviewButtonCard.vue";
import DeviceOverviewHeatingBalanceSliderCard from "@/components/Cards/DeviceOverviewHeatingBalanceSliderCard.vue";
import DashboardCardFaultsPieChart from "@/components/Cards/DashboardCardFaultsPieChart.vue";
import DeviceOverviewRoomTargetCard from "@/components/Cards/DeviceOverviewRoomTargetCard.vue";

@Component({
  components: {
    DashboardCardBarChart,
    DashboardCardPieChart,
    DeviceOverviewCard,
    DeviceOverviewSwitchCard,
    DeviceOverviewButtonCard,
    DeviceOverviewHeatingBalanceSliderCard,
    DeviceOverviewRoomTargetCard,
    DashboardCardFaultsPieChart,
  }
})

export default class IAQGeneralView extends Vue {
 @Prop() device: Record<string, any>;

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh - 230px) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}
</style>
